import { Button, Card, CardContent, Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import defaultImage from '../../../assets/img/default-part.png'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import AddEditPart from '../../Part/AddEditPart'

interface PartSummaryProps {
  part: Part
  qty: number
  type: 'programming' | 'inspection'
}

const PartSummary = ({ part, qty, type }: PartSummaryProps) => {
  const [thumbnailImage, setThumbnailImage] = useState('')
  const [showEditPart, setShowEditPart] = useState(false)
  const [partToEdit, setPartToEdit] = useState<Part | undefined>(undefined)

  useEffect(() => {
    const getThumbnail = async () => {
      try {
        setThumbnailImage(
          `${process.env.REACT_APP_API}/api/thumbnail/${part.thumbnail.id}`
        )
      } catch (error) {
        console.error(error)
      }
    }

    if (
      part &&
      Object.keys(part).length !== 0 &&
      part.thumbnail &&
      Object.keys(part.thumbnail).length !== 0 &&
      part.thumbnail.id !== ''
    ) {
      getThumbnail()
    }
  }, [part])

  const handleEditClick = () => {
    setShowEditPart(true)
    setPartToEdit(part)
  }
  return (
    <>
      <Card className="summary-card">
        <div className="flex space-between header align-center">
          <strong>Part | {part.name}</strong>

          <Button color="primary" onClick={handleEditClick}>
            <span className="underline"> Edit</span>
          </Button>
        </div>

        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <div
                className={thumbnailImage ? 'has-thumbnail' : 'no-thumbnail'}
              >
                <div
                  className={`thumbnail part`}
                  style={{
                    backgroundImage: `url(${
                      thumbnailImage ? thumbnailImage : defaultImage
                    })`,
                  }}
                ></div>
              </div>
            </Grid>

            <Grid item xs={9}>
              <Grid container className="items" spacing={0}>
                {qty && (
                  <>
                    <Grid item xs={3}>
                      Quantity
                    </Grid>
                    <Grid item xs={9}>
                      {qty}
                    </Grid>
                  </>
                )}
                {type === 'programming' && (
                  <>
                    <Grid item xs={3}>
                      Characteristics
                    </Grid>
                    <Grid item xs={9}>
                      {part.numOfCharacteristics}
                    </Grid>
                  </>
                )}

                {type === 'programming' && (
                  <>
                    <Grid item xs={3}>
                      Material
                    </Grid>
                    <Grid item xs={9}>
                      {part.material}
                    </Grid>
                  </>
                )}

                {type === 'programming' && (
                  <>
                    <Grid item xs={3}>
                      Size
                    </Grid>
                    <Grid item xs={9}>
                      {part.size && part.size.x && (
                        <>
                          {part.size.x} / {part.size.y} / {part.size.z}{' '}
                          {part.size.units}
                        </>
                      )}
                    </Grid>
                  </>
                )}
                {type === 'programming' && (
                  <>
                    <Grid item xs={3}>
                      Tolerance
                    </Grid>
                    <Grid item xs={9}>
                      {part.tolerance}
                    </Grid>
                  </>
                )}
                <Grid item xs={3}>
                  Additional notes
                </Grid>
                <Grid item xs={9}>
                  {part.additionalNotes}
                </Grid>
              </Grid>

              <div className="strong m-t-24">Files</div>
              <Grid container className="items" spacing={0}>
                {type === 'programming' && (
                  <>
                    <Grid item xs={3}>
                      Part program files
                    </Grid>
                    <Grid item xs={9}>
                      {part.partProgramFiles &&
                        part.partProgramFiles.map((file, index) => (
                          <div key={index}>{file.name}</div>
                        ))}
                    </Grid>
                  </>
                )}

                {type === 'programming' && part.partProgramLink !== '' && (
                  <>
                    <Grid item xs={3}>
                      Part program link
                    </Grid>
                    <Grid item xs={9}>
                      {part.partProgramLink}
                    </Grid>
                  </>
                )}

                <Grid item xs={3}>
                  Additional documents
                </Grid>
                <Grid item xs={9}>
                  {part.additionalDocuments &&
                    part.additionalDocuments.map((file, index) => (
                      <div key={index}>{file.name}</div>
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {showEditPart && (
        <ModalPopUp
          title="Edit part"
          variant="full"
          setShowModal={setShowEditPart}
          showModal={showEditPart}
        >
          <AddEditPart
            type={type}
            setShowAddPart={setShowEditPart}
            partToEdit={partToEdit}
            setPartToEdit={setPartToEdit}
          />
        </ModalPopUp>
      )}
    </>
  )
}

export default PartSummary
